import React, { useCallback, useMemo } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import BeatLoader from 'react-spinners/PropagateLoader'
import { Content, Login, Flex, Text, Pane } from '@leverege/ui-elements'
import { LoginRoutes } from '@leverege/api-ui-login'

import S from './style.css' 

// export class LoginScreen extends React.Component {
  
//   static contextTypes = {
//     api : PropTypes.object.isRequired
//   }

//   static propTypes = {
//     location : PropTypes.object,
//     auth : PropTypes.object.isRequired
//   }

//   constructor( props ) {
//     super( props )
//     this.state = {
//       forgotPassword : false,
//       loginError : false,
//       email : '',
//       password : '',
//       resetUsername : '',
//       loading : false,
//       checkEmail : false
//     }
//   }

//   forgotPassword( e ) {
//     this.setState( { loginError : false } )
//     this.context.api.forgotPassword( e )
//       .catch( ( err ) => {
//         // nothing
//       } )
//     this.setState( { checkEmail : true } )

//   }

//   onLogin = ( email, password ) => {
//     this.props.auth.login( email, password, ( err, result ) => {
//       this.setState( { loginError : err, loading : false, unauthorized : err && err.unauthorized } )      
//     } )
//     this.setState( { loginError : false, loading : true } )

//   }

//   onLogout = () => {
//     const { checkEmail } = this.state
//     this.setState( { checkEmail : false } )
//   }

//   renderWarning = ( text ) => {
//     const transFormText = text.errorText?.charAt( 0 ).toUpperCase() + text.errorText?.substring( 1 )
    
//     return text.errorText && (
//       <Pane variant="loginWarning" style={{ width : '100%' }}>
//         <Flex variant="rowM">
//           <Text variant="errorIcon"><i className="lv lv-system-error"/></Text>
//           <Text variant="loginWarning">
//             {transFormText}
//           </Text> 
//         </Flex>
//       </Pane>
//     ) 
//   }

//   render() {
//     const { reset } = this.props
//     const { loading, loginError, forgotPassword, checkEmail } = this.state

//     let resetInstruction
//     if ( checkEmail ) {
//       resetInstruction = ( 
//         <Flex variant="colM">
//           <img alt="Logo" src="../../assets/images/success-check.svg" />
//           <Text variant="formTitle|title">Email Sent</Text>
//           <Text variant="formBody">If your email is in our system, you will receive a link to reset your password.</Text>
//         </Flex>
//       )
//     } else {
//       resetInstruction = (
//         <Flex variant="colM">
//           <Text variant="formTitle|title">Reset Password</Text>
//           <Text variant="formBody">Enter the username associated with your account. We’ll send you a link to reset your password.</Text>
//         </Flex>
//       )
//     }

//     let loginText = 'Login'
//     if ( loading ) {
//       loginText = <BeatLoader color="white" css={{ height : '16px' }} />
//     }
  
//     return (
//       <Content>
//         <Content.Area className={S.area}>
//           <Flex direction="row" align="center" justify="center" vFill>
//             <LoginRoutes
//               loginOpts={{
//                 onLogin : this.onLogin
//               }} />
//           </Flex>
//         </Content.Area>
//       </Content>
//     )
//   }
// }

function LoginScreen( props ) {
  return (
    <Content>
      <Content.Area variant="loginBackground" className={S.area}>
        <Flex direction="row" align="center" justify="center" vFill>
          <LoginRoutes />
        </Flex>
      </Content.Area>
    </Content>
  )
}

export default connect( state => ( {
} ) )( LoginScreen )
